export class TranslateConstants {
  public static LANGUAGELIST = ['en', 'fr', 'en-ca'];
}
